import { Injectable } from '@angular/core';
import { Observable, Subject, interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private refreshSubject = new Subject<void>();
refresh$: Observable<void> = this.refreshSubject.asObservable();

  startIntervalRefresh(minutes: number) {
    interval(minutes * 60 * 1000).subscribe(() => {
      this.triggerRefresh();
    });
  }

  triggerRefresh() {
    this.refreshSubject.next();
  }

  // listenTabVisibility() {
  //   document.addEventListener('visibilitychange', () => {
  //     if (document.visibilityState === 'visible') {
  //       this.triggerRefresh();
  //     }
  //   });
  // }
}
